import { Tooltip } from "bootstrap"

export default ({ app }, inject) => {
	let tooltipInstances = []
	let observer = null

	// Initialize tooltips for existing elements
	const initTooltips = () => {
		// Dispose existing tooltips first
		disposeTooltips()

		// Find all tooltip elements
		const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]')
		tooltipInstances = Array.from(tooltipElements).map(element => new Tooltip(element))
	}

	// Dispose all tooltip instances
	const disposeTooltips = () => {
		tooltipInstances.forEach(tooltip => tooltip.dispose())
		tooltipInstances = []
	}

	// Set up MutationObserver to handle dynamically added elements
	const setupObserver = () => {
		if (typeof window !== "undefined") {
			observer = new MutationObserver((mutations) => {
				let shouldReinit = false
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1) { // Element node
							const hasTooltip = node.hasAttribute && node.hasAttribute('data-bs-toggle')
							const containsTooltip = node.querySelectorAll && node.querySelectorAll('[data-bs-toggle="tooltip"]').length > 0
							if (hasTooltip || containsTooltip) {
								shouldReinit = true
							}
						}
					})
				})
				if (shouldReinit) {
					// Use timeout to debounce multiple mutations
					setTimeout(initTooltips, 100)
				}
			})

			observer.observe(document.body, {
				childList: true,
				subtree: true
			})
		}
	}

	// Initialize on DOM ready
	if (process.client) {
		const init = () => {
			initTooltips()
			setupObserver()
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', init)
		} else {
			init()
		}

		// Cleanup on page unload
		window.addEventListener('beforeunload', () => {
			disposeTooltips()
			if (observer) {
				observer.disconnect()
			}
		})
	}

	// Inject methods for manual control if needed
	inject('initTooltips', initTooltips)
	inject('disposeTooltips', disposeTooltips)
}